export const warehouseData = [
  {
    warehouseName: "CWH - Bhiwandi",
    warehouseMainAddress:
      "Ground floor, Survey No. 94/1, 94/2 Khata no. 199/1, 199/2, Koralur Village Kasabahobli, Hoskote, Taluk, Bengaluru, Karnataka 560067",
    pickupAddress: "pickupAddress",
    deliveryAddress: "delivery address",
    warehouseCode: "L903",
    associatedTeamMembers: [
      {
        saasUserID: 38,
        emailID: "deepthi2000@yopmail.com",
        name: "Deepti",
        department: "Operations",
        roleName: "Unknown"
    },
    {
        saasUserID: 35,
        emailID: "qa.manager2@yopmail.com",
      name: "Melissa R. Liu",
      department: "Operations",
        roleName: "QA Head"
    }
    ],
    associatedCDMOs: [
      {
        organizationId: 1,
        organizationName: "Lupin",
        teamMembers: [
          {
            saasUserID: 38,
            emailID: "deepthi2000@yopmail.com",
            name: "Deepti",
            department: "Operations",
            roleName: "Unknown"
        },
        {
            saasUserID: 35,
            emailID: "qa.manager2@yopmail.com",
          name: "Melissa R. Liu",
          department: "Operations",
            roleName: "QA Head"
        }
        ],
      },
    ],
    status: "Active",
    lastUpdatedBy: "Kiran",
    lastUpdatedDate: "",
  },
  {
    warehouseName: "CWH - Pune",
    warehouseMainAddress:
      "Plot No. 45, Hinjewadi Phase 1, Pune, Maharashtra 411057",
    pickupAddress: "pickupAddress",
    deliveryAddress: "delivery address",
    warehouseCode: "P123",
    associatedTeamMembers: [
      {
        saasUserId: 202,
        name: "Sameer",
        department: "Procurement",
        roleName: "Coordinator",
      },
    ],
    associatedCDMOs: [
      {
        organizationId: 2,
        organizationName: "Pfizer",
        teamMembers: [
          {
            saasUserId: 302,
            name: "Neha",
            department: "Distribution",
            roleName: "Executive",
          },
        ],
      },
    ],
    status: "Inactive",
    lastUpdatedBy: "Kiran",
    lastUpdatedDate: "2024-11-19T11:46:59.638Z",
  },
  {
    warehouseName: "CWH - Hyderabad",
    warehouseMainAddress:
      "Survey No. 123, Gachibowli, Hyderabad, Telangana 500032",
    pickupAddress: "pickupAddress",
    deliveryAddress: "delivery address",
    warehouseCode: "H456",
    associatedTeamMembers: [
      {
        saasUserId: 203,
        name: "Vikram",
        department: "Logistics",
        roleName: "Analyst",
      },
    ],
    associatedCDMOs: [
      {
        organizationId: 3,
        organizationName: "Novartis",
        teamMembers: [
          {
            saasUserId: 303,
            name: "Riya",
            department: "Finance",
            roleName: "Lead",
          },
        ],
      },
    ],
    status: "Active",
    lastUpdatedBy: "Kiran",
    lastUpdatedDate: "2024-11-19T11:46:59.638Z",
  },
  {
    warehouseName: "CWH - Delhi",
    warehouseMainAddress: "Sector 18, Dwarka, New Delhi, Delhi 110075",
    pickupAddress: "pickupAddress",
    deliveryAddress: "delivery address",
    warehouseCode: "D789",
    associatedTeamMembers: [
      {
        saasUserId: 204,
        name: "Rohan",
        department: "Transport",
        roleName: "Officer",
      },
    ],
    associatedCDMOs: [
      {
        organizationId: 4,
        organizationName: "Cipla",
        teamMembers: [
          {
            saasUserId: 304,
            name: "Arjun",
            department: "Inventory",
            roleName: "Coordinator",
          },
        ],
      },
    ],
    status: "Inactive",
    lastUpdatedBy: "Kiran",
    lastUpdatedDate: "2024-11-19T11:46:59.638Z",
  },
  {
    warehouseName: "CWH - Chennai",
    warehouseMainAddress: "No. 56, T Nagar, Chennai, Tamil Nadu 600017",
    pickupAddress: "pickupAddress",
    deliveryAddress: "delivery address",
    warehouseCode: "C345",
    associatedTeamMembers: [
      {
        saasUserId: 205,
        name: "Deepa",
        department: "Logistics",
        roleName: "Lead",
      },
    ],
    associatedCDMOs: [
      {
        organizationId: 5,
        organizationName: "Sanofi",
        teamMembers: [
          {
            saasUserId: 305,
            name: "Varun",
            department: "Distribution",
            roleName: "Manager",
          },
        ],
      },
    ],
    status: "Active",
    lastUpdatedBy: "Kiran",
    lastUpdatedDate: "2024-11-19T11:46:59.638Z",
  },
  {
    warehouseName: "CWH - Ahmedabad",
    warehouseMainAddress: "Sarkhej, Ahmedabad, Gujarat 382210",
    pickupAddress: "pickupAddress",
    deliveryAddress: "delivery address",
    warehouseCode: "A567",
    associatedTeamMembers: [
      {
        saasUserId: 206,
        name: "Priya",
        department: "Procurement",
        roleName: "Assistant",
      },
    ],
    associatedCDMOs: [
      {
        organizationId: 6,
        organizationName: "Biocon",
        teamMembers: [
          {
            saasUserId: 306,
            name: "Kiran",
            department: "Logistics",
            roleName: "Supervisor",
          },
        ],
      },
    ],
    status: "Active",
    lastUpdatedBy: "Kiran",
    lastUpdatedDate: "2024-11-19T11:46:59.638Z",
  },
  {
    warehouseName: "CWH - Kolkata",
    warehouseMainAddress: "Salt Lake, Kolkata, West Bengal 700064",
    pickupAddress: "pickupAddress",
    deliveryAddress: "delivery address",
    warehouseCode: "K890",
    associatedTeamMembers: [
      {
        saasUserId: 207,
        name: "Ankur",
        department: "Operations",
        roleName: "Executive",
      },
    ],
    associatedCDMOs: [
      {
        organizationId: 7,
        organizationName: "GSK",
        teamMembers: [
          {
            saasUserId: 307,
            name: "Meera",
            department: "Supply Chain",
            roleName: "Coordinator",
          },
        ],
      },
    ],
    status: "Inactive",
    lastUpdatedBy: "Kiran",
    lastUpdatedDate: "2024-11-19T11:46:59.638Z",
  },
  {
    warehouseName: "CWH - Jaipur",
    warehouseMainAddress: "Sitapura, Jaipur, Rajasthan 302022",
    pickupAddress: "pickupAddress",
    deliveryAddress: "delivery address",
    warehouseCode: "J234",
    associatedTeamMembers: [
      {
        saasUserId: 208,
        name: "Manish",
        department: "Inventory",
        roleName: "Supervisor",
      },
    ],
    associatedCDMOs: [
      {
        organizationId: 8,
        organizationName: "Zydus",
        teamMembers: [
          {
            saasUserId: 308,
            name: "Suman",
            department: "Quality Assurance",
            roleName: "Executive",
          },
        ],
      },
    ],
    status: "Active",
    lastUpdatedBy: "Kiran",
    lastUpdatedDate: "2024-11-19T11:46:59.638Z",
  },
  {
    warehouseName: "CWH - Lucknow",
    warehouseMainAddress: "Hazratganj, Lucknow, Uttar Pradesh 226001",
    pickupAddress: "pickupAddress",
    deliveryAddress: "delivery address",
    warehouseCode: "L678",
    associatedTeamMembers: [
      {
        saasUserId: 209,
        name: "Rakesh",
        department: "Transport",
        roleName: "Coordinator",
      },
    ],
    associatedCDMOs: [
      {
        organizationId: 9,
        organizationName: "Sun Pharma",
        teamMembers: [
          {
            saasUserId: 309,
            name: "Nisha",
            department: "Finance",
            roleName: "Manager",
          },
        ],
      },
    ],
    status: "Inactive",
    lastUpdatedBy: "Kiran",
    lastUpdatedDate: "2024-11-19T11:46:59.638Z",
  },
  {
    warehouseName: "CWH - Mumbai",
    warehouseMainAddress: "Andheri East, Mumbai, Maharashtra 400069",
    pickupAddress: "pickupAddress",
    deliveryAddress: "delivery address",
    warehouseCode: "M901",
    associatedTeamMembers: [
      {
        saasUserId: 210,
        name: "Suresh",
        department: "Operations",
        roleName: "Supervisor",
      },
    ],
    associatedCDMOs: [
      {
        organizationId: 10,
        organizationName: "Dr. Reddy's",
        teamMembers: [
          {
            saasUserId: 310,
            name: "Arti",
            department: "Inventory",
            roleName: "Lead",
          },
        ],
      },
    ],
    status: "Active",
    lastUpdatedBy: "Kiran",
    lastUpdatedDate: "2024-11-19T11:46:59.638Z",
  },
];
